import {
    genericPage,
    getServerSidePropsHelper,
    getSlugEleccio,
    getMappingEleccions3CatInfo,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import { useRouter } from 'next/router';
import __isEmpty from 'lodash/isEmpty';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, [
        'web',
        process.env.FOLDER_LAYOUTS_3CATINFO,
        'eleccions',
        'eleccions-parlament-catalunya-2024',
        'candidats'
    ]);
};

export async function getServerSideProps(context) {
    const basePath = getBasePathEleccio(context?.resolvedUrl);
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }
    let path = [...basePath, 'candidats'];

    const options = {
        slugs: path,
        id: mapping.id,
        slugEleccio
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
